/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClipboardChecklist = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m11.721 10.693-3.084 3.213-2.32-2.176 1.367-1.46.879.825 1.716-1.788zM8.5 18.914l3.207-3.207-1.414-1.414L8.5 16.086l-.793-.793-1.414 1.414zM13 12v-2h4v2zm0 3v2h4v-2z" />
        <path d="M7 2h10v2h4v18H3V4h4zm2 2v2h6V4zm8 4H7V6H5v14h14V6h-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgClipboardChecklist as ClipboardChecklist };
